module.exports = __webpack_public_path__ + "draw.mp3";